module.exports = __webpack_public_path__ + "img/light.f306b8cd.png";